<template>
	<div class="medical-records ">
	    <div class="row diet-section">
	        <div class="col-12 mb-3">
	        	<div class="mobScroll">
		            <ul class="nav nav-tabs noWrap mb-0" role="tablist">
		                <li class="nav-item pl-0"> <a class="nav-link active" data-toggle="tab" href="#recommend"
		                        role="tab">Recommend</a> </li>
		                <li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#low-carb" role="tab">Low Carb</a>
		                </li>
		                <li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#kito-diet" role="tab">Kito Diet</a>
		                </li>
		                <li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#protien-diet" role="tab">High Protien
		                        Diet</a> </li>
		                <li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#paleo" role="tab">Paleo</a> </li>
		            </ul>
		        </div>
	        </div>
	    </div>
	    <div class="row mb-4 food-section">
	        <div class="col-12 diet-sectiom ">
	            <div class="card border-0">
	                <div class="card-body bg-white border-radius-5 p-5">
	                    <!-- Tab panes -->
	                    <div class="tab-content">
	                        <div class="tab-pane active" id="recommend" role="tabpanel">
	                            <div class="row no-gutters d-flex justify-content-center align-items-center recommend">
	                                <div class="col-md-5 text-center">
	                                    <figure class="food-icon mb-4"><img src="../../../../static/website/images/food_icon.svg"></figure>
	                                    <h2>opps! You do not have any recommend food yet!</h2>
	                                    <p>Connect with the Best food consultant.</p>
	                                    <router-link to="recommended-food" class="btn btn-blue ask-dr">Ask a Doctor</router-link>
	                                </div>
	                            </div>
	                        </div>
	                        <div class="tab-pane" id="low-carb" role="tabpanel">
	                            <div class="row no-gutters d-flex justify-content-center align-items-center recommend">
	                                <div class="col-md-5 text-center">
	                                    <figure class="food-icon mb-4"><img src="../../../../static/website/images/food_icon.svg"></figure>
	                                    <h2>opps! You do not have any recommend food yet!</h2>
	                                    <p>Connect with the Best food consultant.</p>
	                                    <router-link to="recommended-food" class="btn btn-blue ask-dr">Ask a Doctor</router-link>
	                                </div>
	                            </div>
	                        </div>
	                        <div class="tab-pane" id="kito-diet" role="tabpanel">
	                            <div class="row no-gutters d-flex justify-content-center align-items-center recommend">
	                                <div class="col-md-5 text-center">
	                                    <figure class="food-icon mb-4"><img src="../../../../static/website/images/food_icon.svg"></figure>
	                                    <h2>opps! You do not have any recommend food yet!</h2>
	                                    <p>Connect with the Best food consultant.</p>
	                                    <router-link to="recommended-food" class="btn btn-blue ask-dr">Ask a Doctor</router-link>
	                                </div>
	                            </div>
	                        </div>
	                        <div class="tab-pane" id="protien-diet" role="tabpanel">
	                            <div class="row no-gutters d-flex justify-content-center align-items-center recommend">
	                                <div class="col-md-5 text-center">
	                                    <figure class="food-icon mb-4"><img src="../../../../static/website/images/food_icon.svg"></figure>
	                                    <h2>opps! You do not have any recommend food yet!</h2>
	                                    <p>Connect with the Best food consultant.</p>
	                                    <router-link to="recommended-food" class="btn btn-blue ask-dr">Ask a Doctor</router-link>
	                                </div>
	                            </div>
	                        </div>
	                        <div class="tab-pane" id="paleo" role="tabpanel">
	                            <div class="row no-gutters d-flex justify-content-center align-items-center recommend">
	                                <div class="col-md-5 text-center">
	                                    <figure class="food-icon mb-4"><img src="../../../../static/website/images/food_icon.svg"></figure>
	                                    <h2>opps! You do not have any recommend food yet!</h2>
	                                    <p>Connect with the Best food consultant.</p>
	                                    <router-link to="recommended-food" class="btn btn-blue ask-dr">Ask a Doctor</router-link>
	                                </div>
	                            </div>
	                        </div>

	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>
	</div>
</template>
<script>
	export default {
        name: 'recommended-diet',

    }
</script>


// WEBPACK FOOTER //
// src/components/website/recommended_diet/recommended-diet.vue